import {Chart, ChartOptions} from "chart.js";


function cssVar(name: string): string {
  return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
}

export function chartOptionsFromCss(): ChartOptions {
  const text = cssVar('--chart-text');
  const grid = cssVar('--chart-grid');
  const border = cssVar('--chart-border');
  const ttBg = cssVar('--chart-tooltip-bg');
  const ttText = cssVar('--chart-tooltip-text');

  const options: any = {
    color: text, 

    borderColor: border,

    plugins: {
      legend: { labels: { color: text } },
      tooltip: {
        backgroundColor: ttBg,
        titleColor: ttText,
        bodyColor: ttText, 
      },
    },

    scales: {
      x: {
        grid: { color: grid, borderColor: border },
        ticks: { color: text },
      },
      y: {
        grid: { color: grid, borderColor: border },
        ticks: { color: text },
      },
    },
  };

  return options;
}

export function applyChartDefaultsFromCss(): void {
  Chart.defaults.set(chartOptionsFromCss()); 
}

export function applyThemeColorsToChart(chart: Chart): void {
  const ttBg = cssVar('--chart-tooltip-bg');
  const ttText = cssVar('--chart-tooltip-text');

  const isDarkMode = document.documentElement.classList.contains('my-app-dark');

  chart.options.plugins ??= {};
  chart.options.plugins.tooltip ??= {};
  chart.options.plugins.tooltip.backgroundColor = ttBg as any;
  chart.options.plugins.tooltip.titleColor = ttText as any;
  chart.options.plugins.tooltip.bodyColor = ttText as any;

  if (isDarkMode) {
    const text = cssVar('--chart-text');
    const grid = cssVar('--chart-grid');
    const border = cssVar('--chart-border');

    chart.options.color = text as any;

    chart.options.plugins.legend ??= {};
    chart.options.plugins.legend.labels ??= {};
    chart.options.plugins.legend.labels.color = text as any;

    const scales = chart.options.scales;
    if (scales) {
      for (const key of Object.keys(scales)) {             
        const s = scales[key]!;
        
        (s as any).ticks ??= {};
        (s as any).ticks.color = text;
        
        (s as any).grid ??= {};
        (s as any).grid.color = grid;
        
        (s as any).border ??= {};
        (s as any).border.color = border;
        (s as any).border.display = true;
      }
    }
  } else {

    chart.options.color = undefined as any;

    if (chart.options.plugins?.legend?.labels) {
      chart.options.plugins.legend.labels.color = undefined as any;
    }

    const scales = chart.options.scales;
    if (scales) {
      for (const key of Object.keys(scales)) {             
        const s = scales[key]!;
        
        if ((s as any).ticks) {
          (s as any).ticks.color = undefined;
        }
        
        if ((s as any).grid) {
          (s as any).grid.color = undefined;
        }
        
        if ((s as any).border) {
          (s as any).border.color = undefined;
        }
      }
    }
  }

  chart.update('none'); 
}